document.addEventListener('DOMContentLoaded', () => {
    // if the modal is on the page and there is a hash link matching the modal id, wire link to modal
    const modals = document.querySelectorAll('.block--modal');
    modals.forEach(modal => {
        const modalId = modal.getAttribute('id');
        const modalLink = document.querySelectorAll(`a[href="#${modalId}"]`);
        modalLink.forEach(link => {
            link.setAttribute('data-bs-toggle', 'modal');
            link.setAttribute('data-bs-target', `#${modalId}`);
            link.setAttribute('role', 'button');
            link.setAttribute('aria-controls', modalId);
            link.setAttribute('id', `${modalId}Label`);

            const initModal = new Modal(modal, {});

            if (!initModal) {
                console.error('Modal not found');
            }

            modal.addEventListener('shown.bs.modal', () => {
                link.focus();
            });
        });
    });
});